import { formCells } from '../columns/tableColumns';

export default {
  data() {
    return {
      baseColumns: [],
      settlementDisabled: false, // 结算
      billingDisabledList: [], // 开票信息
      freightAndRouteDisabled: false, // 商品、线路
      serviceFeeDisabled: false, // 服务计费规则
      productServiceDisabled: false, // 产品服务类型
      uploadDisabled: false,
      deleteFileDisabled: false, // 附件
      accountInfoDisabled: false, // 无用
    };
  },
  methods: {
    assignBaseColumnsStatus(baseInfoData) {
      let expirationDateDisabled = baseInfoData.hasExpirationDate == '1';
      this.baseColumns = this.baseColumns.map((item) => {
        if (item.prop == 'contractExpireDate') {
          return { ...item, disabled: expirationDateDisabled };
        } else {
          return item;
        }
      });
    },
    getProcessedBaseColumns(status = '', origin) {
      let tl = formCells(this);
      // origin == 'supplement'从列表按钮“结算条款”点击进入 create: 创建  copy：复制  createFrom: 项目转合同 detail：详情
      // pageMode：0代表创建，1代表详情页查看状态，2代表详情页编辑状态
      // status 已驳回 已停用 修订已驳回 已保存 修订审批中 审批中 已生效
      console.log('formStatus', status, origin);

      if (origin == 'create' || origin == 'copy') {
        this.baseColumns = tl.map((item) => {
          if (item.prop == 'projectCode') {
            return {
              name: '项目编号',
              prop: 'projectCode',
              type: 'searchTableSpec',
              changeMethod: 'changeMethod',
              currentValue: this.baseInfoData.projectCode,
              searchType: 'projectIntermodality',
              isMultiple: true,
            };
          } else {
            return item;
          }
        });
        return;
      }

      if (origin != 'create' && origin != 'createFrom' && origin != 'copy') {
        if (!this.isCustomerContract) {
          tl = tl.map((item) => {
            if (item.prop == 'projectCode') {
              return {
                name: '项目编号',
                prop: 'projectCodeList',
                type: 'input',
                disabled: true,
              };
            } else if (item.prop == 'projectName') {
              return {
                name: '项目名称',
                prop: 'projectNameList',
                type: 'input',
                disabled: true,
              };
            } else {
              return item;
            }
          });
        } else {
          let list = ['projectName', 'projectCode'];
          tl = tl.map((item) => {
            if (list.includes(item.prop)) {
              return { ...item, disabled: true };
            } else {
              return item;
            }
          });
        }
      }
      if (status == '审批中' || status == '已生效') {
        this.deleteFileDisabled = true;
      }
      //上面是先期处理

      if (
        status == '审批中' ||
        status == '已停用' ||
        status == '修订审批中' ||
        this.pageMode == 1 ||
        (origin == 'supplement' && status != '已生效')
      ) {
        this.baseColumns = tl.map((item) => {
          return { ...item, disabled: true };
        });
        this.billingDisabledList = [
          'taxpayerName',
          'taxpayerIdentifyCode',
          'accountBank',
          'accountBankNo',
          'addressPhone',
          'vatInvoiceType',
        ];
        this.serviceFeeDisabled = true;
        this.accountInfoDisabled = true;
        this.uploadDisabled = true;
        this.settlementDisabled = true;
        this.freightAndRouteDisabled = true;
        this.serviceFeeDisabled = true;
        if (origin == 'supplement') this.productServiceDisabled = false;
        else this.productServiceDisabled = true;
        return;
      }
      if ((status == '已生效' && origin == 'supplement') || this.baseInfoData.contractType == '1') {
        this.baseColumns = tl.map((item) => {
          return { ...item, disabled: true };
        });
        this.uploadDisabled = false;
        this.settlementDisabled = false;
        this.deleteFileDisabled = false;
        this.billingDisabledList = [
          'taxpayerName',
          'taxpayerIdentifyCode',
          'accountBank',
          'accountBankNo',
          'addressPhone',
          'vatInvoiceType',
        ];
        this.freightAndRouteDisabled = origin == 'supplement' ? false : true;
        this.serviceFeeDisabled = false;
        if (
          origin == 'supplement' ||
          (this.baseInfoData.contractType == '1' &&
            (status == '已保存' || status == '已驳回') &&
            origin == 'detail')
        )
          this.productServiceDisabled = false;
        else this.productServiceDisabled = true;
        this.accountInfoDisabled = true;
        return;
      }

      if (origin == 'createFrom' || status == '已保存' || status == '已驳回') {
        this.accountInfoDisabled = false;
        this.productServiceDisabled = false;
        this.settlementDisabled = false;
        this.uploadDisabled = false;
        this.deleteFileDisabled = false;
        this.freightAndRouteDisabled = false;
        this.serviceFeeDisabled = false;
        this.billingDisabledList = [
          'accountBank',
          'accountBankNo',
          'addressPhone',
          'taxpayerName',
          'taxpayerIdentifyCode',
        ];
        let list = [
          'contractCode',
          'createDepartmentName',
          // 'saleDepartmentName',
          // 'signTitle',
          'customerCode',
          'supplierCode',
          'projectName',
          'projectCode',
          'contractType',
        ];
        this.baseColumns = tl.map((item) => {
          if (list.includes(item.prop)) {
            return { ...item, disabled: true };
          } else {
            return item;
          }
        });
        return;
      }

      if (status == '已生效' || status == '修订已驳回') {
        this.productServiceDisabled = true;
        this.serviceFeeDisabled = true;
        this.settlementDisabled = true;
        this.freightAndRouteDisabled = true;
        this.uploadDisabled = false;
        this.deleteFileDisabled = false;
        this.accountInfoDisabled = false;
        this.billingDisabledList = [
          'accountBank',
          'accountBankNo',
          'addressPhone',
          'taxpayerName',
          'taxpayerIdentifyCode',
        ];
        let list = [
          'contractCode',
          'createDepartmentName',
          // 'saleDepartmentName',
          // 'signTitle',
          'customerCode',
          'supplierCode',
          'projectName',
          'projectCode',
          'contractType',
        ];
        this.baseColumns = tl.map((item) => {
          if (list.includes(item.prop)) {
            return { ...item, disabled: true };
          } else {
            return item;
          }
        });
        return;
      }
    },
  },
  computed: {},
  mounted() {
    this.baseColumns = formCells(this);
  },
};
